import React from "react";
import CandidateForm from "./CandidateForm";
import CandidateFormHeader from "./CandidateFormHeader";

const MainCandidateForm = () => {
  return (
    <div>
      <CandidateFormHeader />
      <CandidateForm />
    </div>
  );
};

export default MainCandidateForm;
